import React from 'react';
import { TABS } from '../tabs';

interface MobileNavProps {
  activeTab: string;
  setActiveTab: (tab: any) => void;
}

export const MobileNav: React.FC<MobileNavProps> = ({ activeTab, setActiveTab }) => {
  const NavItem = ({ id, label, icon }: { id: string, label: string, icon: string }) => (
    <div 
      onClick={() => setActiveTab(id)}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.2rem', color: activeTab === id ? 'var(--accent-primary)' : 'var(--text-secondary)', cursor: 'pointer' }}
    >
      <span style={{ fontSize: '1.25rem' }}>{icon}</span>
      <span style={{ fontSize: '0.65rem', fontWeight: activeTab === id ? 600 : 400 }}>{label}</span>
    </div>
  );

  return (
    <div className="app-bottom-nav">
      {TABS.filter(t => t.mobile).map(t => <NavItem key={t.id} id={t.id} label={t.mobileLabel ?? t.label} icon={t.icon} />)}
    </div>
  );
};
